import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from '@angular/fire/firestore';

export interface Role {
  announcer?: boolean;
  organizer?: boolean;
  admin?: boolean;
}

export interface User {
  uid?: string;
  displayName: string;
  email?: string | null;
  roles: Role;
}

export const userConverter: FirestoreDataConverter<User> = {
  toFirestore(user: User): DocumentData {
    return {
      uid: user.uid ?? null,
      displayName: user.displayName,
      email: user.email,
      roles: user.roles,
    };
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ): User {
    const data = snapshot.data(options);
    return {
      uid: data['uid'],
      displayName: data['displayName'],
      email: data['email'],
      roles: data['roles'],
    };
  },
};
